import { defineMessages } from 'react-intl';

export default defineMessages({
  bibliography: {
    id: 'Bibliography',
    defaultMessage: 'Bibliography',
  },
});
